<template>
  <div class="app-container" style="width: 100%; height: 100vh; display: flex">
    <iframe :src="iframeUrl" frameborder="0" style="flex: 1" />
  </div>
</template>

<script>
import { getDashboardParams } from '@/api/orderApi';

export default {
  // 运输看板
  name: 'EndKanbanBoard04',
  data() {
    return {
      iframeUrl: ''
    };
  },
  activated() {
    getDashboardParams(2).then((res) => {
      if (res.code === 200) {
        this.iframeUrl = `https://sharegray.tcbi.qq.com/page/embed?authType=${res.data?.authType}&pageId=${res.data?.pageId}&projectId=${res.data?.projectId}&scope=${res.data?.scope}&token=${res.data?.token}`;
      }
    });
  },
  created() {
    getDashboardParams(2).then((res) => {
      if (res.code === 200) {
        this.iframeUrl = `https://sharegray.tcbi.qq.com/page/embed?authType=${res.data?.authType}&pageId=${res.data?.pageId}&projectId=${res.data?.projectId}&scope=${res.data?.scope}&token=${res.data?.token}`;
      }
    });
  },
  methods: {}
};
</script>

<style scoped></style>
